import { useQuery } from "@tanstack/react-query"
import { getPurchaseOrderAttachment } from "customerAttachments/apis"
import { PurchaseAttachType } from "customerAttachments/types"

type useGetAttachmentProps = {
  orderNo: string
  attachType: PurchaseAttachType
}

const useGetPurchaseAttachment = ({ orderNo, attachType }: useGetAttachmentProps) => {
  const { data, isLoading, isSuccess } = useQuery({
    enabled: !!orderNo && !!attachType,
    queryKey: ["purchaseAttach", orderNo, attachType],
    queryFn: () => getPurchaseOrderAttachment({ orderNo, attachType }),
    select: (data) => data?.Data,
    staleTime: 0,
    cacheTime: 0,
  })
  return { data, isLoading, isSuccess }
}

export default useGetPurchaseAttachment
